"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.UserHeaderNav = exports.UserUnloggedHeaderNav = void 0;
const tslib_1 = require("tslib");
const jsx_runtime_1 = require("react/jsx-runtime");
const Identity_1 = require("@reactionable/core/lib/identity/Identity");
const UserHeaderNav_1 = require("@reactionable/core/lib/ui/layout/header/UserHeaderNav");
const Nav_1 = tslib_1.__importDefault(require("react-bootstrap/Nav"));
const NavDropdown_1 = tslib_1.__importDefault(require("react-bootstrap/NavDropdown"));
var UserHeaderNav_2 = require("@reactionable/core/lib/ui/layout/header/UserHeaderNav");
Object.defineProperty(exports, "UserUnloggedHeaderNav", { enumerable: true, get: function () { return UserHeaderNav_2.UserUnloggedHeaderNav; } });
const UserLoggedHeaderNav = () => {
    const { user, displayName } = Identity_1.useIdentityContext();
    if (!user) {
        return null;
    }
    return (jsx_runtime_1.jsxs(NavDropdown_1.default, Object.assign({ id: "userLoggedHeaderNav", title: displayName(), alignRight: true }, { children: [jsx_runtime_1.jsx(UserHeaderNav_1.AccountLink, { NavItemComponent: NavDropdown_1.default.Item }, void 0),
            jsx_runtime_1.jsx(NavDropdown_1.default.Divider, {}, void 0),
            jsx_runtime_1.jsx(UserHeaderNav_1.LogoutLink, { NavItemComponent: NavDropdown_1.default.Item }, void 0)] }), void 0));
};
const UserHeaderNav = () => {
    const { identityProvider } = Identity_1.useIdentityContext();
    if (!identityProvider) {
        return null;
    }
    return (jsx_runtime_1.jsxs(jsx_runtime_1.Fragment, { children: [jsx_runtime_1.jsx(UserLoggedHeaderNav, {}, void 0),
            jsx_runtime_1.jsx(UserHeaderNav_1.UserUnloggedHeaderNav, { NavItemComponent: Nav_1.default.Link }, void 0)] }, void 0));
};
exports.UserHeaderNav = UserHeaderNav;
//# sourceMappingURL=UserHeaderNav.js.map